const { History } = require( '@leverege/api-redux' )

const Actions = History( { reduxKey : 'imagineHistory' } )

Object.assign( module.exports, Actions )
